import { render, staticRenderFns } from "./TrainList.vue?vue&type=template&id=ff4c24b6"
import script from "./TrainList.vue?vue&type=script&lang=js"
export * from "./TrainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports